import React, { useCallback } from 'react';
import { MultiSelectDropdown, debounce } from 'freemium-ui';
import { useTranslation } from 'react-i18next';
import { useGetTags } from 'routes/screens/response/hooks';

const TagFilterDropdown = ({
  label,
  selected,
  placeholder,
  handleChange,
  ...rest
}: any) => {
  const [selectedItems, setSelectedItems] = React.useState(
    selected ? selected.value : [],
  );
  const [tagName, setTagName] = React.useState('');
  const { t } = useTranslation();

  const {
    data: tagsData = [],
    refetch: refetchTags,
    isLoading: isTagsLoading,
    isFetching: isTagsFetching,
  } = useGetTags({ searchParam: tagName });

  const handleInputChange = (inputVal: string) => {
    if (inputVal.length) {
      debouncedSearch();
      setTagName(inputVal);
    }
  };

  const debouncedSearch = useCallback(
    debounce(() => {
      refetchTags();
    }, 500),
    [],
  );

  const updateValues = (items: any) => {
    const payload = {
      type: 'MULTISELECT',
      value: items,
    };
    setSelectedItems(items);
    handleChange(payload);
  };

  React.useEffect(() => {
    if (!selected) {
      setSelectedItems([]);
    } else setSelectedItems(selected?.value);
  }, [selected]);

  return (
    <MultiSelectDropdown
      name={t(label)}
      items={tagsData?.accountTags || []}
      selectedItem={selectedItems}
      onChange={updateValues}
      isMenuLoading={isTagsFetching || isTagsLoading}
      customValues
      itemLabelIdentifier="name"
      itemValueIdentifier="name"
      label={t(label)}
      placeholder={selectedItems?.length ? '' : t(placeholder)}
      handleInputChange={handleInputChange}
      isDynamicMenu
      {...rest}
    />
  );
};

export default TagFilterDropdown;
